__webpack_require__.p = "/news-quiz/";